import 'styled-components';
// declare module 'react' {
//   interface Attributes {
//     css?: CSSProp | CSSObject;
//   }
// }
export const getTheme = (props) => props.theme;
export const isBKJThemeType = (theme) => theme.__discriminator === 'BKJThemeType';
export const assertBKJThemeType = (ComponentName, props) => {
    const isThemeTypeValid = isBKJThemeType(getTheme(props));
    if (!isThemeTypeValid)
        throw new Error(`${ComponentName}: You should not use <${ComponentName} /> outside of <BKJThemeProvider />`);
    return '';
};
//# sourceMappingURL=BKJThemeProvider.types.js.map